module.exports = __webpack_public_path__ + "media/images/app/checkout/fake-radio-btn-e2fc05e6bd8068b43c02957e1d9637e7.svg";